export type StoryBibleSectionKey =
  | "seed"
  | "genre"
  | "style"
  | "synopsis"
  | "characters"
  | "worldbuilding"
  | "outline";

export type StoryBibleGeneratedEntity = {
  entityType: "character" | "worldbuilding" | "outline_chapter" | "story_bible_section";
  entityId: string;
  name: string;
  description?: string;
};

const STORY_BIBLE_SECTION_KEYS = new Set<string>([
  "seed",
  "genre",
  "style",
  "synopsis",
  "characters",
  "worldbuilding",
  "outline",
]);

export function parseStoryBibleGeneratedEntity(value: unknown): StoryBibleGeneratedEntity | null {
  if (!value || typeof value !== "object") return null;
  const record = value as Record<string, unknown>;
  const entityType = record.entityType;
  if (
    entityType !== "character"
    && entityType !== "worldbuilding"
    && entityType !== "outline_chapter"
    && entityType !== "story_bible_section"
  ) {
    return null;
  }
  const entityId = typeof record.entityId === "string" ? record.entityId.trim() : "";
  const name = typeof record.name === "string" ? record.name.trim() : "";
  if (!entityId || !name) return null;
  if (entityType === "story_bible_section" && !STORY_BIBLE_SECTION_KEYS.has(entityId)) {
    return null;
  }
  const description = typeof record.description === "string" ? record.description.trim() : undefined;
  return {
    entityType,
    entityId,
    name,
    ...(description ? { description } : {}),
  };
}

export function storyBibleGeneratedEntityMentionId(entity: StoryBibleGeneratedEntity): string {
  if (entity.entityType === "outline_chapter") {
    return `outline::${entity.entityId}`;
  }
  if (entity.entityType === "story_bible_section") {
    return `story-bible-section::${entity.entityId}`;
  }
  return `${entity.entityType}::${entity.entityId}`;
}
